// ============================================
// Achievement System — replaces AchievementManager.cs
// Categories: Milestone (10), Story (82), Gameplay (41). 4 entries are
// patreonOnly (all Story; free build shows 129 via _visibleList()), 47 are
// hidden:true (shown as "?" until earned; hidden is a separate flag from
// patreonOnly and still counts in the panel total).
// Persisted in localStorage, checked on events
// ============================================

import { events, Events } from '../engine/events.js';
import { L } from './localization.js';
import { isPat } from '../engine/pgate.js';

const STORAGE_KEY = 'PnO_Achievements';

/**
 * Achievement categories.
 */
export const AchievementCategory = {
    Milestone: 'Milestone',
    Story: 'Story',
    Gameplay: 'Gameplay',
};

/**
 * All achievement definitions.
 */
const ALL_ACHIEVEMENTS = [
    // ===== MILESTONES (synced from Ink milestone variables) =====
    { id: 'milestone_fem_10', title: 'Pink Curious', description: 'Reach 10 Femininity', category: AchievementCategory.Milestone, inkVariable: 'milestone_fem_10' },
    { id: 'milestone_fem_25', title: 'Embracing Pink', description: 'Reach 25 Femininity', category: AchievementCategory.Milestone, inkVariable: 'milestone_fem_25' },
    { id: 'milestone_fem_50', title: 'Pretty in Pink', description: 'Reach 50 Femininity', category: AchievementCategory.Milestone, inkVariable: 'milestone_fem_50' },
    { id: 'milestone_fem_75', title: 'Full Blossom', description: 'Reach 75 Femininity', category: AchievementCategory.Milestone, inkVariable: 'milestone_fem_75' },
    { id: 'milestone_fem_100', title: 'True Self', description: 'Reach 100 Femininity', category: AchievementCategory.Milestone, inkVariable: 'milestone_fem_100' },
    { id: 'milestone_sub_10', title: 'Yielding', description: 'Reach 10 Submissiveness', category: AchievementCategory.Milestone, inkVariable: 'milestone_sub_10' },
    { id: 'milestone_sub_25', title: 'Obedient', description: 'Reach 25 Submissiveness', category: AchievementCategory.Milestone, inkVariable: 'milestone_sub_25' },
    { id: 'milestone_sub_50', title: 'Devoted', description: 'Reach 50 Submissiveness', category: AchievementCategory.Milestone, inkVariable: 'milestone_sub_50' },
    { id: 'milestone_sub_75', title: 'Completely Owned', description: 'Reach 75 Submissiveness', category: AchievementCategory.Milestone, inkVariable: 'milestone_sub_75' },
    { id: 'milestone_sub_100', title: 'Perfect Obedience', description: 'Reach 100 Submissiveness', category: AchievementCategory.Milestone, inkVariable: 'milestone_sub_100' },

    // ===== STORY ACHIEVEMENTS (triggered by #achievement: tag in Ink) =====
    { id: 'uniform_accepted', title: 'Dressed for the Job', description: 'Accept the bar uniform', category: AchievementCategory.Story },
    { id: 'first_shift', title: 'First Shift', description: 'Complete your first bar shift', category: AchievementCategory.Story },
    { id: 'first_salon', title: 'Beautification', description: 'Visit the salon for the first time', category: AchievementCategory.Story },
    { id: 'body_hairless', title: 'Smooth', description: 'Complete all laser hair removal sessions', category: AchievementCategory.Story },
    { id: 'long_hair', title: 'Long Locks', description: 'Get hair extensions', category: AchievementCategory.Story },
    { id: 'first_manicure', title: 'Manicured', description: 'Get your nails done at the salon', category: AchievementCategory.Story },
    { id: 'first_piercing', title: 'Pierced', description: 'Get your first piercing', category: AchievementCategory.Story },
    { id: 'toy_sizeup', title: 'Sizing Up', description: 'Outgrow a toy and graduate to the next size', category: AchievementCategory.Gameplay },
    { id: 'glory_hole_discovery', title: 'Curiosity', description: 'Discover the glory hole', category: AchievementCategory.Story },
    { id: 'first_photoshoot', title: 'On Camera', description: 'Complete your first photographer shoot', category: AchievementCategory.Story },
    { id: 'photographer_portfolio', title: 'Published Model', description: 'Launch your online portfolio', category: AchievementCategory.Story },
    { id: 'club_access', title: 'VIP Access', description: 'Gain entry to the nightclub', category: AchievementCategory.Story },
    { id: 'club_first_shift', title: 'Go-Go Girl', description: 'Complete your first club shift', category: AchievementCategory.Story },
    { id: 'office_personal_assistant', title: 'His Right Hand', description: "Become Mr. Hartwell's personal assistant", category: AchievementCategory.Story },
    { id: 'office_boss_complete', title: 'Corner Office', description: 'Complete the after-hours encounter with Mr. Hartwell', category: AchievementCategory.Story, hidden: true },
    { id: 'maid_first_shift', title: 'New Hire', description: 'Complete your first cleaning shift', category: AchievementCategory.Story },
    { id: 'maid_personal', title: 'Personal Touch', description: 'Become a personal maid', category: AchievementCategory.Story },
    { id: 'maid_victor_complete', title: 'Private Arrangement', description: "Accept Victor's private arrangement", category: AchievementCategory.Story, hidden: true },
    { id: 'cafe_first_shift', title: 'Nyan Nyan!', description: 'Complete your first shift at the maid cafe', category: AchievementCategory.Story },
    { id: 'first_date', title: 'First Date', description: 'Go on your first dating app date', category: AchievementCategory.Story },
    { id: 'sissy_profile', title: 'Online Presence', description: 'Create a sissy dating profile', category: AchievementCategory.Story },
    { id: 'sugar_first', title: 'Sugar and Spice', description: 'Go on your first sugar daddy date', category: AchievementCategory.Story },
    { id: 'kept_sissy', title: 'Kept Woman', description: 'Accept the kept sissy proposal', category: AchievementCategory.Story, hidden: true },
    { id: 'ending_kept_sissy', title: 'His Forever', description: 'Reach the Kept Sissy ending', category: AchievementCategory.Story, hidden: true },
    { id: 'ending_perfect_sissy', title: 'Perfect', description: 'Reach the ending at 100 Femininity and 100 Submissiveness', category: AchievementCategory.Story, hidden: true },
    { id: 'ending_hard_mode', title: 'Hard Way', description: 'Reach the ending on Hard difficulty', category: AchievementCategory.Story, hidden: true },
    { id: 'ending_challenge_mode', title: 'Unbreakable', description: 'Reach the ending on Challenge difficulty', category: AchievementCategory.Story, hidden: true },
    { id: 'ending_independent', title: 'On My Own Terms', description: 'Reach the Independent ending', category: AchievementCategory.Story, hidden: true },
    { id: 'ending_famous', title: 'Going Live', description: 'Reach the Famous ending', category: AchievementCategory.Story, hidden: true },
    { id: 'ending_masc', title: 'His Own Man', description: 'Reach the Masculine ending', category: AchievementCategory.Story, hidden: true },
    { id: 'ending_kept_her', title: 'Hers Forever', description: 'Reach the Kept by Her ending', category: AchievementCategory.Story, hidden: true },
    { id: 'ending_superstar', title: 'Superstar', description: 'Reach the Famous ending with max fame, subscribers, and reputation', category: AchievementCategory.Story, hidden: true },
    { id: 'every_order_fulfilled', title: 'Perfect Obedient', description: 'Fulfill every order from your Master', category: AchievementCategory.Story, hidden: true },
    { id: 'cuckolded', title: 'Betrayed', description: 'Watch your girlfriend with another man', category: AchievementCategory.Story, hidden: true },
    { id: 'stream_caught', title: 'The Algorithm Knows', description: 'Get caught by your girlfriend through your own stream', category: AchievementCategory.Story, hidden: true },
    { id: 'threesome', title: 'The New Normal', description: 'Join the threesome dynamic', category: AchievementCategory.Story, hidden: true },
    { id: 'rent_consequence', title: 'Consequences', description: 'Fail to pay rent on time', category: AchievementCategory.Story, hidden: true },
    { id: 'prologue_completed', title: 'New Life', description: 'Finish the prologue', category: AchievementCategory.Story },
    { id: 'first_chastity', title: 'Locked Up', description: 'Wear the chastity cage for the first time', category: AchievementCategory.Story },
    { id: 'flat_cage', title: 'Smaller Still', description: 'Switch to the flat chastity cage', category: AchievementCategory.Story, hidden: true },
    { id: 'master_collar', title: 'Collared', description: "Accept your Master's collar", category: AchievementCategory.Story },
    { id: 'cage_walked_away', title: 'Own Two Feet', description: 'On your own terms, take the cage off and leave it in the drawer', category: AchievementCategory.Story },
    // ===== v0.2.8 — Chastity depth, keyholders, construction, kitten tail =====
    { id: 'cage_permanent', title: 'Sealed for Good', description: 'Accept the permanent lock, no key, no going back', category: AchievementCategory.Story, hidden: true },
    { id: 'cage_earned_relief', title: 'Earned a Night', description: 'Be granted a relief night out of the cage', category: AchievementCategory.Story, hidden: true },
    { id: 'cage_cut_off', title: 'Cut Loose', description: 'Have the back-alley locksmith cut a keyholder-locked cage off', category: AchievementCategory.Story, hidden: true },
    { id: 'cage_ninety_days', title: 'Thirty Days Sealed', description: 'Stay permanently locked for thirty days', category: AchievementCategory.Story, hidden: true },
    { id: 'derek_keyholder', title: 'His to Unlock', description: 'Make Derek from the office your keyholder', category: AchievementCategory.Story, hidden: true },
    { id: 'sarah_keyholder', title: 'Her Key', description: 'Hand your cage key to Sarah on her dominant path', category: AchievementCategory.Story, hidden: true },
    { id: 'construction_job', title: 'Hard Hat', description: 'Take the construction site job downtown', category: AchievementCategory.Story },
    { id: 'construction_architect', title: 'Drawing the Lines', description: "Reach the architect's private office on the construction route", category: AchievementCategory.Story, hidden: true },
    // ===== HypnoMind conditioning (0.2.9; freed + kill-switch stripped 2026-07-07) =====
    { id: 'hypno_unlocked', title: 'Let Her In', description: 'Complete your first HypnoMind session', category: AchievementCategory.Story, hidden: true },
    { id: 'hypno_deepening', title: 'Going Under', description: 'Reach Deepening on the HypnoMind conditioning gauge', category: AchievementCategory.Story, hidden: true },
    { id: 'hypno_surrendered', title: 'Hers Completely', description: 'Reach full Surrender on the HypnoMind conditioning gauge', category: AchievementCategory.Story, hidden: true },
    { id: 'hypno_all_categories', title: 'Every Lesson', description: 'Try all six HypnoMind conditioning categories', category: AchievementCategory.Story, hidden: true },
    { id: 'hypno_public_trigger', title: 'It Follows You', description: 'Feel her conditioning surface on its own in public', category: AchievementCategory.Story, hidden: true },
    { id: 'kitten_tail', title: 'Good Kitten', description: 'Wear the kitten tail where someone notices it', category: AchievementCategory.Story },
    { id: 'public_challenges_complete', title: 'Good Girl', description: "Complete all 7 of Master's public challenges", category: AchievementCategory.Story, hidden: true },
    { id: 'girlfriend_accepts', title: 'She Knows', description: 'Your girlfriend accepts the new you', category: AchievementCategory.Story },
    { id: 'girlfriend_breakup', title: 'Closure', description: 'Your girlfriend ends the relationship after the discovery', category: AchievementCategory.Story },
    { id: 'girlfriend_open', title: 'Polyamory Pact', description: 'Sign the open relationship deal with your girlfriend', category: AchievementCategory.Story },
    { id: 'girlfriend_dom', title: 'Hers, Specifically', description: 'Sign the new shape with your girlfriend, she runs it now', category: AchievementCategory.Story },
    { id: 'dating_stage3', title: 'Going Steady', description: 'Reach Stage 3 with any dating NPC', category: AchievementCategory.Story },
    { id: 'hrt_started', title: 'New Chemistry', description: 'Start hormone treatment', category: AchievementCategory.Story },
    { id: 'first_stream', title: 'Debut', description: 'Complete your first stream', category: AchievementCategory.Story },
    { id: 'dare_first', title: 'Dare Accepted', description: 'Complete your first DareMe challenge', category: AchievementCategory.Story },

    // ===== GAMEPLAY ACHIEVEMENTS =====
    { id: 'fame_25', title: 'Getting Noticed', description: 'Reach 25 Sissy Fame', category: AchievementCategory.Gameplay },
    { id: 'fame_50', title: 'Internet Famous', description: 'Reach 50 Sissy Fame', category: AchievementCategory.Gameplay },
    { id: 'fame_75', title: 'Sissy Star', description: 'Reach 75 Sissy Fame', category: AchievementCategory.Gameplay },
    { id: 'rich', title: 'Sugar Money', description: 'Have $5000 at once', category: AchievementCategory.Gameplay },
    { id: 'broke', title: 'Rock Bottom', description: 'Have $0 with rent due', category: AchievementCategory.Gameplay, hidden: true },
    { id: 'day_7', title: 'First Week', description: 'Survive your first week', category: AchievementCategory.Gameplay },
    { id: 'day_30', title: 'One Month', description: 'Survive 30 days', category: AchievementCategory.Gameplay },
    { id: 'day_60', title: 'Two Months', description: 'Survive 60 days', category: AchievementCategory.Gameplay },
    { id: 'all_locations', title: 'Explorer', description: 'Visit every location', category: AchievementCategory.Gameplay },
    { id: 'full_wardrobe', title: 'Fashion Icon', description: 'Own 15 clothing items', category: AchievementCategory.Gameplay },
    { id: 'stream_veteran', title: 'Regular', description: 'Complete 10 streams', category: AchievementCategory.Gameplay },
    { id: 'stream_star', title: 'Cam Star', description: 'Complete 25 streams', category: AchievementCategory.Gameplay },
    { id: 'stream_amazing', title: 'Showstopper', description: 'Earn $200+ tips in a single stream', category: AchievementCategory.Gameplay },
    { id: 'stream_viral', title: 'Trending', description: 'Have a stream clip go viral', category: AchievementCategory.Gameplay, hidden: true },
    { id: 'first_collab', title: 'Duo Stream', description: 'Complete your first collab stream', category: AchievementCategory.Gameplay },
    { id: 'stream_celeb', title: 'Platform Star', description: 'Reach 1000 followers', category: AchievementCategory.Gameplay },
    { id: 'stream_top_earner', title: 'Top Earner', description: 'Reach $10,000 cumulative stream tips', category: AchievementCategory.Gameplay },
    { id: 'domme_stream', title: 'In Control', description: 'Complete a Domme Request stream', category: AchievementCategory.Gameplay, hidden: true },
    { id: 'all_categories', title: 'Category Queen', description: 'Stream in every category', category: AchievementCategory.Gameplay },
    { id: 'upgrade_bed_max', title: 'Sweet Dreams', description: 'Fully upgrade your bed', category: AchievementCategory.Gameplay },
    { id: 'upgrade_desk_max', title: 'Pro Setup', description: 'Fully upgrade your streaming desk', category: AchievementCategory.Gameplay },
    { id: 'upgrade_vanity_max', title: 'Mirror Mirror', description: 'Fully upgrade your vanity', category: AchievementCategory.Gameplay },
    { id: 'upgrade_decor_max', title: 'Personal Sanctuary', description: 'Fully upgrade your apartment decor', category: AchievementCategory.Gameplay },
    { id: 'patron', title: 'Angel', description: 'Support the game on Patreon', category: AchievementCategory.Gameplay },
    { id: 'blowjob_10', title: 'Natural Talent', description: 'Complete 10 oral encounters', category: AchievementCategory.Gameplay, hidden: true },
    { id: 'anal_10', title: 'Experienced', description: 'Complete 10 anal encounters', category: AchievementCategory.Gameplay, hidden: true },
    { id: 'hookup_10', title: 'Popular', description: 'Complete 10 hookups', category: AchievementCategory.Gameplay, hidden: true },
    { id: 'shame_50', title: 'Self-Conscious', description: 'Reach 50 Shame', category: AchievementCategory.Gameplay },
    { id: 'shameless', title: 'Shameless', description: 'Reduce Shame back to 0 after reaching 50', category: AchievementCategory.Gameplay, hidden: true },
    { id: 'complete_set', title: 'Matching Set', description: 'Wear a complete outfit set', category: AchievementCategory.Gameplay },
    { id: 'toy_master', title: 'Advanced Training', description: 'Own all three sizes of a toy', category: AchievementCategory.Gameplay, hidden: true },
    { id: 'all_dating_npcs', title: 'Player', description: 'Go on a date with every dating NPC', category: AchievementCategory.Gameplay, hidden: true },
    { id: 'vincent_used', title: 'Used', description: 'Reach Stage 3 with Vincent', category: AchievementCategory.Story, hidden: true, patreonOnly: true },

    // ===== NPC FIRST-MEET / FIRST-DATE ACHIEVEMENTS =====
    // Auto-unlocked from JS by polling dating_X / NPC stage VARs.
    // No Ink edits required — fires when the relevant counter goes 0 -> >=1.
    { id: 'first_date_tyler', title: 'Coffee with Tyler', description: 'Meet Tyler for your first date', category: AchievementCategory.Story },
    { id: 'first_date_kai', title: 'Boba Date', description: 'Meet Kai for your first date', category: AchievementCategory.Story },
    { id: 'first_date_owen', title: 'Quiet Cafe', description: 'Meet Owen for your first date', category: AchievementCategory.Story },
    { id: 'first_date_patrick', title: "Patrick's Place", description: 'Meet Patrick for the first time', category: AchievementCategory.Story, hidden: true, patreonOnly: true },
    { id: 'first_date_vincent', title: "Vincent's Domain", description: 'Meet Vincent for the first time', category: AchievementCategory.Story, hidden: true, patreonOnly: true },
    { id: 'vivienne_met', title: 'Velvet Welcome', description: 'Make an impression on Vivienne at the Velvet Lounge', category: AchievementCategory.Story },
    { id: 'dante_met', title: 'Cabana Boy', description: 'Catch Dante\'s eye at the resort cabana', category: AchievementCategory.Story },
    { id: 'iris_met', title: 'Front Desk', description: 'Get noticed by Iris at the resort', category: AchievementCategory.Story },
    { id: 'jade_met', title: 'Walked Into Inkwell', description: 'Meet Jade at the tattoo studio', category: AchievementCategory.Story },
    { id: 'malik_met', title: 'Personal Trainer', description: 'Catch Malik\'s eye at the gym', category: AchievementCategory.Story },
    { id: 'dominic_met', title: 'Healing Hands', description: 'Book your first massage with Dominic', category: AchievementCategory.Story },
    { id: 'dr_mercer_met', title: 'Initial Consult', description: 'See Dr. Mercer for the first time', category: AchievementCategory.Story },

    // ===== G-05 v0.2.5 — INDEPENDENT-PATH ACHIEVEMENTS =====
    // Owner-route has Day 7 / 14 / 21 milestones, MR-stages, kept_sissy ending.
    // Independent-route had nothing equivalent. These three frame the same
    // arc beats from the no-Master angle. All three require master_intensity == 0.
    { id: 'independent_dress', title: 'I picked my own dress', description: 'Reach 30 Femininity on the Independent path. Every step of the way was your call', category: AchievementCategory.Gameplay },
    { id: 'independent_dom', title: 'I made him beg', description: 'Reach 50 Submissiveness on the Independent path without a Master driving it. You knelt because you chose to, not because you were told', category: AchievementCategory.Gameplay },
    { id: 'independent_self_made', title: 'Self-made femboy', description: 'Save $1500 with 60 Femininity on the Independent path. You built this on your own terms', category: AchievementCategory.Gameplay },

    // ===== v0.2.7 ACHIEVEMENTS =====
    // Auto-unlocked from JS by polling Ink VARs in the achievement-poll loop
    // (see NPC_MEET_MAP and the v0.2.7 extension below). Patreon-only
    // achievements are hidden:true so they don't tease locked content.
    { id: 'basement_lease',         title: 'Basement Lease',          description: 'Lease the basement workshop below your apartment',                  category: AchievementCategory.Gameplay },
    { id: 'playroom_convert',       title: 'Spare Room Conversion',    description: 'Convert the spare room into a dedicated playroom',                 category: AchievementCategory.Gameplay },
    { id: 'nest_tier_2',            title: 'Lived-in',                description: 'Reach apartment Nest Tier 2 by buying decor in Apartment Upgrades', category: AchievementCategory.Gameplay },
    { id: 'nest_tier_3',            title: 'Feminine Sanctuary',       description: 'Reach apartment Nest Tier 3 (4+ decor items + Vanity upgrade)',     category: AchievementCategory.Gameplay },
    { id: 'first_workshop_master',  title: 'Down to the Basement',     description: 'Invite Master to the basement workshop for the first time',         category: AchievementCategory.Story },
    { id: 'first_playroom_visit',   title: 'Position Mat',             description: 'Enter the playroom for the first time',                            category: AchievementCategory.Story },
    { id: 'comfort_training_mastery', title: 'Trained Tolerance',      description: 'Complete the 8th session on Waist Trainer, Nipple Clamps, Wrist Cuffs AND Training Heels', category: AchievementCategory.Gameplay, hidden: true },
    { id: 'sarah_dom_accepted',     title: 'Her Turn',                 description: 'Accept Sarah\'s Domme offer on a Saturday',                         category: AchievementCategory.Story, hidden: true },
    { id: 'wellness_unlocked',      title: 'Wellness Program',         description: 'Unlock Master\'s Wellness Program at MR 9',                         category: AchievementCategory.Story, hidden: true },
    { id: 'first_date_scar',        title: 'Renaissance Fair',         description: 'Meet Scar at the Renaissance Fair tailoring booth',                category: AchievementCategory.Story, hidden: true, patreonOnly: true },
    // Free Use track (0.3.1 poll #2). All Story + hidden + patreonOnly (unlock is
    // Patreon-gated → filtered off free builds by _visibleList). FREE_USE.md §6.
    { id: 'free_use_first',         title: 'Open Invitation',          description: 'Wear the anklet and get used for the first time',                  category: AchievementCategory.Story, hidden: true, patreonOnly: true },
    { id: 'free_use_all_venues',    title: 'Public Utility',           description: 'Get used at the bar, the club, the gym AND the park',              category: AchievementCategory.Story, hidden: true, patreonOnly: true },
    { id: 'free_use_devoted',       title: 'Always Available',         description: 'Reach House Rules, the standing arrangement',                      category: AchievementCategory.Story, hidden: true, patreonOnly: true },

    // 0.3.1 Kennel Expansion (KENNEL_EXPANSION.md §2.9), 4 Patreon-scene
    // achievements + one free-earnable (the switch session is base content;
    // its Ink emission + sync re-derive are v031-gated so nothing pops while
    // the kill-switch is dormant).
    { id: 'kennel_kitten_track',    title: 'Show Cat',                 description: 'Hold your place at the Kennel\'s invite-only kitten show',         category: AchievementCategory.Story, hidden: true, patreonOnly: true },
    { id: 'kennel_puppy_track',     title: 'Best in Show',             description: 'Finish the long walk to the park gate and back',                   category: AchievementCategory.Story, hidden: true, patreonOnly: true },
    { id: 'kennel_graduation',      title: 'Collared by Mira',         description: 'Accept Mira\'s own collar and the name that comes with it',        category: AchievementCategory.Story, hidden: true, patreonOnly: true },
    { id: 'kennel_auction_stranger', title: 'Sold to the Room',        description: 'Be won for an evening by a buyer with no name',                    category: AchievementCategory.Story, hidden: true, patreonOnly: true },
    { id: 'kennel_switch',          title: 'Bilingual',                description: 'Hold both headspaces in a single Kennel session',                  category: AchievementCategory.Story, hidden: true },
];

// Build lookup by ID
const ACHIEVEMENT_BY_ID = new Map(ALL_ACHIEVEMENTS.map(a => [a.id, a]));

// Total Gameplay-category achievements. Used as the perf short-circuit ceiling
// for the stat pollers (once every gameplay achievement is unlocked, stop
// re-checking). Computed from the array so it self-updates when entries are
// added, instead of a hardcoded constant that silently drifts (the old
// hardcoded 35 lagged the real 40 and let the poller stop 5 short).
const GAMEPLAY_ACHIEVEMENT_COUNT = ALL_ACHIEVEMENTS.filter(
    a => a.category === AchievementCategory.Gameplay,
).length;

class AchievementManager {
    constructor() {
        /** @type {Set<string>} unlocked achievement IDs */
        this._unlocked = new Set();
        this._gameplayUnlocked = 0;
        this._dirty = false;
        this._saveTimer = null;
        // When true, unlock() records + persists silently (no toast, no SFX).
        // Set during load-time re-derivation so restoring a save doesn't flood
        // the player with toasts/sounds for already-earned achievements.
        this._suppressToast = false;

        // Load from localStorage
        this._loadFromStorage();

        // Periodic save (30s)
        this._saveTimer = setInterval(() => this._flushIfDirty(), 30000);

        // Listen for events (scoped so destroy() can tear them down)
        this._scope = events.createScope('achievements');
        this._scope.on(Events.TAG_ACHIEVEMENT, (id) => this.unlock(id));
        this._scope.on(Events.STAT_CHANGED, (stat, value) => this._onStatChanged(stat, value));
        this._scope.on(Events.ITEM_PURCHASED, () => this._onItemPurchased());
    }

    // ---- Core ----

    /**
     * Unlock an achievement by ID.
     */
    unlock(id) {
        if (this._unlocked.has(id)) return;

        const data = ACHIEVEMENT_BY_ID.get(id);
        if (!data) {
            console.warn(`[Achievements] Unknown achievement: '${id}'`);
            return;
        }

        this._unlocked.add(id);
        this._dirty = true;

        if (data.category === AchievementCategory.Gameplay) {
            this._gameplayUnlocked++;
        }

        const lTitle = this.getLocalizedTitle(data);
        const lDesc = this.getLocalizedDesc(data);
        console.log(`[Achievements] Unlocked: ${lTitle}`);
        // Silent path: load-time re-derivation records + persists without toast.
        if (this._suppressToast) return;
        events.emit(Events.AUDIO_SFX_PLAY, 'you_win1');
        events.emit(Events.ACHIEVEMENT_UNLOCKED, id, lTitle, lDesc);
        // Persist immediately on a live unlock instead of waiting for the 30s
        // timer. Closes the "earned an achievement, closed the tab, lost it"
        // gap (foundby player 0.2.7.2: "achievements not saved correctly").
        this._flushIfDirty();
    }

    isUnlocked(id) {
        return this._unlocked.has(id);
    }

    // ---- Localization helpers ----

    /**
     * Get localized title for an achievement. Falls back to English data field.
     */
    getLocalizedTitle(achOrId) {
        const data = typeof achOrId === 'string' ? ACHIEVEMENT_BY_ID.get(achOrId) : achOrId;
        if (!data) return '???';
        const key = 'achiev.' + data.id + '.title';
        const val = L.get(key);
        return val !== key ? val : data.title;
    }

    /**
     * Get localized description for an achievement. Falls back to English data field.
     */
    getLocalizedDesc(achOrId) {
        const data = typeof achOrId === 'string' ? ACHIEVEMENT_BY_ID.get(achOrId) : achOrId;
        if (!data) return '';
        const key = 'achiev.' + data.id + '.desc';
        const val = L.get(key);
        return val !== key ? val : data.description;
    }

    // ---- Queries ----

    /**
     * Achievements visible on the current build. Patreon-exclusive entries
     * (patreonOnly: true) are filtered out on the free build so players never
     * see locked tiles they can never earn, and so the panel total reflects
     * the actually-attainable set. Patreon build sees the full list.
     */
    _visibleList() {
        try {
            if (!isPat()) return ALL_ACHIEVEMENTS.filter(a => !a.patreonOnly);
        } catch (e) { /* pgate unavailable, show everything */ }
        return ALL_ACHIEVEMENTS;
    }

    getAll() {
        return this._visibleList();
    }

    getById(id) {
        return ACHIEVEMENT_BY_ID.get(id) ?? null;
    }

    getUnlockedCount() {
        const visible = this._visibleList();
        if (visible.length === ALL_ACHIEVEMENTS.length) return this._unlocked.size;
        let count = 0;
        for (const a of visible) if (this._unlocked.has(a.id)) count++;
        return count;
    }

    getTotalCount() {
        return this._visibleList().length;
    }

    getUnlockedIds() {
        return Array.from(this._unlocked);
    }

    /**
     * Get count of unlocked gameplay achievements (used as perk points).
     */
    getGameplayPoints() {
        let count = 0;
        for (const id of this._unlocked) {
            const data = ACHIEVEMENT_BY_ID.get(id);
            if (data?.category === AchievementCategory.Gameplay) count++;
        }
        return count;
    }

    getCategoryCount(category) {
        let unlocked = 0;
        let total = 0;
        for (const a of this._visibleList()) {
            if (a.category !== category) continue;
            total++;
            if (this._unlocked.has(a.id)) unlocked++;
        }
        return { unlocked, total };
    }

    // ---- Sync from Ink ----

    /**
     * Sync milestone achievements from Ink story variables.
     * Call after loading a game.
     * @param {function} readVar - (varName) => value
     */
    syncMilestonesFromInk(readVar) {
        for (const a of ALL_ACHIEVEMENTS) {
            if (a.category !== AchievementCategory.Milestone) continue;
            if (!a.inkVariable) continue;

            try {
                const val = readVar(a.inkVariable);
                const unlocked = (typeof val === 'boolean') ? val : (typeof val === 'number' && val !== 0);
                if (unlocked && !this._unlocked.has(a.id)) {
                    this._unlocked.add(a.id);
                    this._dirty = true;
                    console.log(`[Achievements] Synced milestone: ${a.title}`);
                }
            } catch(e) {
                // Variable not found — skip
            }
        }

        // Retroactive NPC first-meet unlocks for saves made before this
        // update — read each VAR via the same readVar helper so save-loaded
        // state surfaces immediately rather than waiting for the next
        // Energy/Day tick.
        const NPC_MEET_MAP = [
            ['first_date_tyler',   'dating_tyler'],
            ['first_date_kai',     'dating_kai'],
            ['first_date_owen',    'dating_owen'],
            ['first_date_patrick', 'dating_patrick'],
            ['first_date_vincent', 'dating_vincent'],
            ['first_date_scar',    'dating_scar'],
            ['vivienne_met',       'vivienne_relationship'],
            ['dante_met',          'dante_stage'],
            ['iris_met',           'iris_stage'],
            ['jade_met',           'jade_visits'],
            ['malik_met',          'trainer_stage'],
            ['dominic_met',        'masseur_stage'],
            ['dr_mercer_met',      'doctor_stage'],
            // v0.2.7 Workshop / Playroom / Sarah Domme / Wellness gates
            ['first_workshop_master', 'workshop_master_stage'],
            ['first_playroom_visit',  'apartment_has_playroom'],
        ];
        for (const [achId, varName] of NPC_MEET_MAP) {
            if (this._unlocked.has(achId)) continue;
            try {
                const val = Number(readVar(varName)) || 0;
                if (val >= 1) this.unlock(achId);
            } catch (e) { /* missing var */ }
        }

        // v0.2.7 boolean-flag achievements (true => unlock)
        const FLAG_UNLOCK_MAP = [
            ['basement_lease',          'apartment_has_basement'],
            ['playroom_convert',        'apartment_has_playroom'],
            ['comfort_training_mastery','comfort_mastery_unlocked'],
            ['wellness_unlocked',       'master_wellness_unlocked'],
        ];
        for (const [achId, varName] of FLAG_UNLOCK_MAP) {
            if (this._unlocked.has(achId)) continue;
            try {
                const v = readVar(varName);
                if (v === true || v === 1 || Number(v) >= 1) this.unlock(achId);
            } catch (e) { /* missing var */ }
        }

        // v0.2.7 threshold-based achievements
        if (!this._unlocked.has('nest_tier_2')) {
            try { if ((Number(readVar('apartment_nest_tier')) || 0) >= 2) this.unlock('nest_tier_2'); } catch (e) {}
        }
        if (!this._unlocked.has('nest_tier_3')) {
            try { if ((Number(readVar('apartment_nest_tier')) || 0) >= 3) this.unlock('nest_tier_3'); } catch (e) {}
        }
        if (!this._unlocked.has('sarah_dom_accepted')) {
            try { if ((Number(readVar('sarah_arc')) || 0) === 5) this.unlock('sarah_dom_accepted'); } catch (e) {}
        }

        // Free Use track (0.3.1) — re-derive from persisted route VARs (save.js
        // routeKeys). The live #achievement: tags can be missed on a mid-drain
        // bail or a reload right at the beat; free_use_count / free_use_stage /
        // the 4 venue bools survive, so heal on load (ENDING_ACH lesson). FREE_USE.md §6.
        try {
            if (!this._unlocked.has('free_use_first') && (Number(readVar('free_use_count')) || 0) >= 1) this.unlock('free_use_first');
            if (!this._unlocked.has('free_use_devoted') && (Number(readVar('free_use_stage')) || 0) >= 3) this.unlock('free_use_devoted');
            if (!this._unlocked.has('free_use_all_venues')) {
                const _fuv = ['free_use_bar_done', 'free_use_club_done', 'free_use_gym_done', 'free_use_park_done'];
                if (_fuv.every((v) => { const x = readVar(v); return x === true || x === 1; })) this.unlock('free_use_all_venues');
            }
        } catch (e) { /* missing var */ }

        // Kennel Expansion (0.3.1), re-derive from persisted route VARs
        // (save.js routeKeys), same ENDING_ACH lesson as Free Use. Gated on the
        // shared v031 kill-switch so nothing pops while dormant; kennel_switch
        // additionally back-fills old saves (switch_session_done is base
        // content shipped in 0.2.6). KENNEL_EXPANSION.md §2.9.
        try {
            const _v031 = readVar('v031_content_enabled');
            if (_v031 === true || _v031 === 1) {
                const _kt = (v) => { const x = readVar(v); return x === true || x === 1; };
                if (!this._unlocked.has('kennel_kitten_track') && _kt('kitten_stage_4_done')) this.unlock('kennel_kitten_track');
                if (!this._unlocked.has('kennel_puppy_track') && _kt('puppy_stage_4_done')) this.unlock('kennel_puppy_track');
                if (!this._unlocked.has('kennel_graduation') && _kt('mira_collar_owned')) this.unlock('kennel_graduation');
                if (!this._unlocked.has('kennel_auction_stranger') && (Number(readVar('auction_winner')) || 0) === 4) this.unlock('kennel_auction_stranger');
                if (!this._unlocked.has('kennel_switch') && _kt('switch_session_done')) this.unlock('kennel_switch');
            }
        } catch (e) { /* missing var */ }

        // 0.2.9 HypnoMind conditioning (Patreon, v029-gated). Driven by the app's
        // own stat (hypnomind_depth), stage, per-category tried flags + trigger cycle.
        try {
            if (!this._unlocked.has('hypno_unlocked') && (Number(readVar('hypnomind_stage')) || 0) >= 1) this.unlock('hypno_unlocked');
            const hd = Number(readVar('hypnomind_depth')) || 0;
            if (!this._unlocked.has('hypno_deepening') && hd >= 40) this.unlock('hypno_deepening');
            if (!this._unlocked.has('hypno_surrendered') && hd >= 60) this.unlock('hypno_surrendered');
            if (!this._unlocked.has('hypno_public_trigger') && (Number(readVar('hypnomind_trigger_cycle')) || 0) >= 1) this.unlock('hypno_public_trigger');
            if (!this._unlocked.has('hypno_all_categories')) {
                const _hc = ['fem', 'obey', 'oral', 'bimbo', 'exhib', 'anal'];
                if (_hc.every((c) => { const v = readVar('hypnomind_tried_' + c); return v === true || v === 1; })) this.unlock('hypno_all_categories');
            }
        } catch (e) { /* missing var */ }

        // Story endings — re-derive from the persisted `ending_reached` route VAR
        // (+ difficulty_score / quality thresholds). Every OTHER achievement
        // category has a VAR-based safety net here; endings were the one class
        // granted solely by the one-shot live `#achievement:` tag at endgame, with
        // no reload recovery. If that tag's dispatch is missed for any reason (a
        // mid-drain _processStoryContent generation bail, a reload right at the
        // end screen, the tag landing on a whitespace-only Continue() line, or an
        // older build), the player permanently lost the ending achievement. This
        // heals it on next load since `ending_reached` is persisted (save.js
        // routeKeys). foundby:Inciteful (reached the Kept ending, no achievement).
        try {
            const ENDING_ACH = {
                kept: 'ending_kept_sissy',
                independent: 'ending_independent',
                famous: 'ending_famous',
                masc: 'ending_masc',
                kept_her: 'ending_kept_her',
            };
            const ending = readVar('ending_reached');
            const endAch = ENDING_ACH[ending];
            if (endAch) {
                if (!this._unlocked.has(endAch)) this.unlock(endAch);
                // Difficulty variants fire on ANY ending (difficulty_score is set
                // at game start, never drifts — fully safe to re-derive).
                const diff = Number(readVar('difficulty_score')) || 0;
                if (diff >= 3 && !this._unlocked.has('ending_hard_mode')) this.unlock('ending_hard_mode');
                if (diff >= 5 && !this._unlocked.has('ending_challenge_mode')) this.unlock('ending_challenge_mode');
                // Quality variants — same thresholds the Ink ending knots check.
                if (ending === 'kept' && !this._unlocked.has('ending_perfect_sissy')
                    && (Number(readVar('Femininity')) || 0) >= 100 && (Number(readVar('Submissiveness')) || 0) >= 100) {
                    this.unlock('ending_perfect_sissy');
                }
                if (ending === 'famous' && !this._unlocked.has('ending_superstar')
                    && (Number(readVar('sissy_fame')) || 0) >= 90 && (Number(readVar('onlyfems_subscribers')) || 0) >= 250 && (Number(readVar('stream_reputation')) || 0) >= 90) {
                    this.unlock('ending_superstar');
                }
            }
        } catch (e) { /* missing var */ }

        this._flushIfDirty();
    }

    /**
     * Check all gameplay achievements against current state.
     * @param {function} readVar - (varName) => value
     * @param {object} deps - { inventoryManager, statisticsTracker }
     */
    checkGameplayAchievements(readVar, deps = {}) {
        if (this._gameplayUnlocked >= GAMEPLAY_ACHIEVEMENT_COUNT) return;

        // Day milestones
        try {
            const day = readVar('Day');
            if (day >= 7) this.unlock('day_7');
            if (day >= 30) this.unlock('day_30');
            if (day >= 60) this.unlock('day_60');
        } catch(e) { if (window.localStorage?.getItem?.('PnO_Debug') === 'true') console.warn('[Achievements] check threw:', e?.message); }

        // Money
        try {
            const money = readVar('Money');
            if (money >= 5000) this.unlock('rich');
            if (money <= 0) this.unlock('broke');
        } catch(e) { if (window.localStorage?.getItem?.('PnO_Debug') === 'true') console.warn('[Achievements] check threw:', e?.message); }

        // Fame
        try {
            const fame = readVar('sissy_fame');
            if (fame >= 25) this.unlock('fame_25');
            if (fame >= 50) this.unlock('fame_50');
            if (fame >= 75) this.unlock('fame_75');
        } catch(e) { if (window.localStorage?.getItem?.('PnO_Debug') === 'true') console.warn('[Achievements] check threw:', e?.message); }

        // Shame
        try {
            const shame = readVar('Shame');
            if (shame >= 50) this.unlock('shame_50');
            if (shame <= 0 && this.isUnlocked('shame_50')) this.unlock('shameless');
        } catch(e) { if (window.localStorage?.getItem?.('PnO_Debug') === 'true') console.warn('[Achievements] check threw:', e?.message); }

        // Wardrobe count
        if (deps.inventoryManager) {
            const ownedCount = deps.inventoryManager.getOwnedTags().length;
            if (ownedCount >= 15) this.unlock('full_wardrobe');
            if (deps.inventoryManager.hasAnyActiveSetBonus()) this.unlock('complete_set');
        }

        // Locations visited
        if (deps.statisticsTracker) {
            if (deps.statisticsTracker.getLocationCount() >= 10) this.unlock('all_locations');
            if (deps.statisticsTracker.getStat('blowjob') >= 10) this.unlock('blowjob_10');
            if (deps.statisticsTracker.getStat('anal') >= 10) this.unlock('anal_10');
            if (deps.statisticsTracker.getStat('hookup') >= 10) this.unlock('hookup_10');
        }

        // Toy progression
        try {
            const dildoTier = readVar('dildo_tier');
            const plugTier = readVar('plug_tier');
            if (dildoTier >= 3 || plugTier >= 3) this.unlock('toy_master');
        } catch(e) { if (window.localStorage?.getItem?.('PnO_Debug') === 'true') console.warn('[Achievements] check threw:', e?.message); }

        // G-05 v0.2.5: Independent-path milestones. master_intensity == 0
        // means the player picked Independent in the editor — the Owner
        // SMS-driven beats (Day 7/14/21 milestones, MR stages) never fire,
        // so this branch needs its own progress markers.
        try {
            const intensity = readVar('master_intensity');
            if (intensity === 0) {
                const fem = readVar('Femininity');
                const sub = readVar('Submissiveness');
                const money = readVar('Money');
                const mr = readVar('MasterRelationship');
                if (fem >= 30) this.unlock('independent_dress');
                // 'I made him beg' guards on low MR — confirms the Sub stat
                // was earned solo (dating NPCs, dares, brothel work) rather
                // than leaked from a Master-relationship that shouldn't exist
                // on this path. MR <= 2 covers any residual perk_master_favor
                // edge case, see character-editor.js perk_master_favor gate.
                if (sub >= 50 && (mr || 0) <= 2) this.unlock('independent_dom');
                if (money >= 1500 && fem >= 60) this.unlock('independent_self_made');
            }
        } catch(e) { /* missing var on legacy save */ }

        // All dating NPCs
        try {
            const allMet = readVar('matched_tyler')
                        && readVar('matched_kai')
                        && readVar('matched_raven')
                        && readVar('matched_owen');
            if (allMet) this.unlock('all_dating_npcs');
        } catch(e) { if (window.localStorage?.getItem?.('PnO_Debug') === 'true') console.warn('[Achievements] check threw:', e?.message); }

        this._flushIfDirty();
    }

    /**
     * Re-derive every achievement from the restored game state after a save
     * load. Silent (no toast / SFX), this is restoration, not earning, and
     * fully idempotent (already-unlocked IDs short-circuit). Both helpers it
     * calls had "Call after loading a game" docstrings but no call site, so
     * the load path only ran restoreFromSave(savedArray); any save whose
     * achievement array was stale or empty (old save format, or itch.io
     * iframe where the localStorage-only store was partitioned away) showed
     * no progress even though the Ink milestone flags were set. Re-deriving
     * from story.variablesState self-heals it.
     * @param {function} readVar - (varName) => value
     * @param {object} deps - { inventoryManager, statisticsTracker }
     */
    restoreFromGameState(readVar, deps = {}) {
        this._suppressToast = true;
        try {
            this.syncMilestonesFromInk(readVar);
            this.checkGameplayAchievements(readVar, deps);
        } catch (e) {
            console.warn('[Achievements] restoreFromGameState threw:', e?.message);
        } finally {
            this._suppressToast = false;
        }
        this._dirty = true;
        this._flushIfDirty();
    }

    // ---- Event handlers ----

    _onStatChanged(stat, value) {
        // NPC first-meet/first-date achievements (Story category) poll on any
        // stat tick — dating scenes always end with an Energy/Money/Fem mutation
        // so this catches the unlock moment without observing 12 narrative VARs.
        // MUST run before the gameplay-completion early-return below, or these
        // Story unlocks are silently skipped once all Gameplay achievements are
        // earned.
        if (stat === 'Energy' || stat === 'Money' || stat === 'Day' || stat === 'Femininity' || stat === 'Submissiveness') {
            this._checkNpcFirstMeets();
        }

        if (this._gameplayUnlocked >= GAMEPLAY_ACHIEVEMENT_COUNT) return;

        if (stat === 'Day') {
            if (value >= 7) this.unlock('day_7');
            if (value >= 30) this.unlock('day_30');
            if (value >= 60) this.unlock('day_60');
        }
        if (stat === 'Money') {
            if (value >= 5000) this.unlock('rich');
            if (value <= 0) this.unlock('broke');
        }
        if (stat === 'Shame') {
            if (value >= 50) this.unlock('shame_50');
            if (value <= 0 && this.isUnlocked('shame_50')) this.unlock('shameless');
        }
        // G-05 v0.2.5: Independent-path achievements fire when the relevant
        // stat crosses on a no-Master run. Multi-variable, so we re-query
        // current state on every Femininity / Submissiveness / Money tick.
        if (stat === 'Femininity' || stat === 'Submissiveness' || stat === 'Money') {
            this._checkIndependentAchievements();
        }
    }

    /**
     * Poll NPC first-meet / first-date counters and unlock the matching
     * Story achievements when they cross 0 -> >= 1. Reads Ink state directly
     * via window._sm so it works on every stat-change tick.
     */
    _checkNpcFirstMeets() {
        try {
            const story = (typeof window !== 'undefined' && window._sm)
                ? window._sm.currentStory : null;
            if (!story) return;
            const v = (n) => { try { return Number(story.variablesState[n]) || 0; } catch(e) { return 0; } };
            const NPC_MEET_MAP = [
                ['first_date_tyler',   'dating_tyler'],
                ['first_date_kai',     'dating_kai'],
                ['first_date_owen',    'dating_owen'],
                ['first_date_patrick', 'dating_patrick'],
                ['first_date_vincent', 'dating_vincent'],
                ['vivienne_met',       'vivienne_relationship'],
                ['dante_met',          'dante_stage'],
                ['iris_met',           'iris_stage'],
                ['jade_met',           'jade_visits'],
                ['malik_met',          'trainer_stage'],
                ['dominic_met',        'masseur_stage'],
                ['dr_mercer_met',      'doctor_stage'],
            ];
            for (const [achId, varName] of NPC_MEET_MAP) {
                if (this._unlocked.has(achId)) continue;
                if (v(varName) >= 1) this.unlock(achId);
            }
        } catch (e) { /* missing var on legacy save */ }
    }

    /**
     * G-05 v0.2.5: Independent-path threshold check. Re-queried on every
     * Fem / Sub / Money change. Reads Ink state directly via storyManager
     * so it stays correct even when called from event-handler path
     * (variableManager observers are stat-specific, can't co-query).
     */
    _checkIndependentAchievements() {
        try {
            const story = (typeof window !== 'undefined' && window._sm)
                ? window._sm.currentStory : null;
            if (!story) return;
            const intensity = story.variablesState['master_intensity'];
            if (intensity !== 0) return;
            const fem = story.variablesState['Femininity'] || 0;
            const sub = story.variablesState['Submissiveness'] || 0;
            const money = story.variablesState['Money'] || 0;
            const mr = story.variablesState['MasterRelationship'] || 0;
            if (fem >= 30) this.unlock('independent_dress');
            // 'I made him beg' guards on low MR — confirms Sub was earned solo
            // (dating NPCs, dares, brothel work) not leaked from a hidden
            // Master-relationship that shouldn't exist on master_intensity 0.
            // MR <= 2 covers any residual perk_master_favor edge case.
            if (sub >= 50 && mr <= 2) this.unlock('independent_dom');
            if (money >= 1500 && fem >= 60) this.unlock('independent_self_made');
        } catch (e) { /* missing var on legacy save */ }
    }

    _onItemPurchased() {
        // Check wardrobe achievement — requires inventoryManager to be wired externally
        // This is checked in checkGameplayAchievements instead
    }

    // ---- Persistence ----

    _loadFromStorage() {
        try {
            const json = localStorage.getItem(STORAGE_KEY);
            if (json) {
                const ids = JSON.parse(json);
                if (Array.isArray(ids)) {
                    for (const id of ids) {
                        this._unlocked.add(id);
                        const data = ACHIEVEMENT_BY_ID.get(id);
                        if (data?.category === AchievementCategory.Gameplay) {
                            this._gameplayUnlocked++;
                        }
                    }
                }
            }
        } catch (e) {
            console.warn('[Achievements] Failed to load from storage:', e);
        }
    }

    _saveToStorage() {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(this._unlocked)));
        } catch (e) {
            console.warn('[Achievements] Failed to save:', e);
        }
    }

    _flushIfDirty() {
        if (this._dirty) {
            this._saveToStorage();
            this._dirty = false;
        }
    }

    /**
     * Restore from save data (e.g. imported save).
     */
    restoreFromSave(unlockedIds) {
        if (!Array.isArray(unlockedIds)) return;
        for (const id of unlockedIds) {
            if (!this._unlocked.has(id)) {
                this._unlocked.add(id);
                const data = ACHIEVEMENT_BY_ID.get(id);
                if (data?.category === AchievementCategory.Gameplay) {
                    this._gameplayUnlocked++;
                }
            }
        }
        this._dirty = true;
        this._flushIfDirty();
    }

    /**
     * Reset all achievements (new game).
     */
    reset() {
        this._unlocked.clear();
        this._gameplayUnlocked = 0;
        this._dirty = true;
        this._flushIfDirty();
    }

    destroy() {
        if (this._saveTimer) {
            clearInterval(this._saveTimer);
            this._saveTimer = null;
        }
        if (this._scope) {
            this._scope.destroy();
            this._scope = null;
        }
        this._flushIfDirty();
    }
}

export const achievementManager = new AchievementManager();
